import $ from 'jquery'

// eslint-disable-next-line no-undef
const object = nrjObject

$.ui.autocomplete.prototype._resizeMenu = function () {
  var ul = this.menu.element
  ul.outerWidth(this.element.outerWidth())
}

$('.filter-toggle').on('click', () => {
  $('.part-filter').toggleClass('part-filter--active')

  if ($('.part-filter').hasClass('part-filter--active')) {
    $('body').addClass('filter-active')
  } else {
    $('body').removeClass('filter-active')
  }
})

$('.part-filter__autocomplete')
  .autocomplete({
    minLength: 3,
    appendTo: '.part-filter__wrapper',
    source: function (request, response) {
      $.ajax({
        url: object.ajaxUrl,
        type: 'POST',
        dataType: 'JSON',
        data: {
          nonce: object.nonce,
          action: 'nrj_get_posts',
          keyword: request.term,
          postType: $('.part-filter').attr('data-post-type'),
        },
        success: function (res) {
          response(res.data.data)
        },
      })
    },
    search: function (event) {
      $(event.target).parents('.part-filter').find('.vn-loader').show()
    },
    open: function (event) {
      $(event.target).parents('.part-filter').find('.vn-loader').hide()
      $(event.target).addClass('autocomplete-active')
    },
    close: function (event) {
      $(event.target).removeClass('autocomplete-active')
    },
    create: function () {
      $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
        return $('<li>')
          .append(
            `<a href="${item.url}" class="res-class">${
              item.thumbnail ? `<img src="${item.thumbnail}" alt="${item.name}">` : ''
            }${item.title}</a>`
          )
          .appendTo(ul)
      }
    },
  })
  .focus(function () {
    $(this).data('uiAutocomplete').search($(this).val())
  })
